import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as ShipmentRelationActions from './shipment-relations.actions';
import * as ShipmentRelationSelectors from './shipment-relations.selectors';

@Injectable()
export class ShipmentRelationsFacade {
    quotation$ = this.store.pipe(
        select(ShipmentRelationSelectors.getShipmentQuotation)
    );

    loading$ = this.store.pipe(
        select(ShipmentRelationSelectors.getShipmentRelationsLoading)
    );

    error$ = this.store.pipe(
        select(ShipmentRelationSelectors.getShipmentRelationsError)
    );

    constructor(private store: Store) {}

    init(shipmentId: string) {
        this.store.dispatch(ShipmentRelationActions.init({ shipmentId }));
    }
}
